<template>
  <div class="Sobre" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'Aviso'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'Aviso'"></homeNav>
      </div>

      <div class="libe_home_banner">
        <div class="libe_home_banner_img">
          <img src="../assets/imgs/introduc_banner01.jpg" alt="">
        </div>
      </div>

      <div class="product_wrap">
        <!--<div class="product_cont">
          <img src="../assets/imgs/product_01.png" alt="">
        </div>-->
        <div class="product_cont">
          <img src="../assets/imgs/product_02.png" alt="">
        </div>
        <div class="product_cont">
          <img src="../assets/imgs/product_03.png" alt="">
        </div>
        <div class="product_cont">
          <img src="../assets/imgs/product_04.png" alt="">
        </div>
        <div class="product_cont" style="padding-bottom: 120px;">
          <img src="../assets/imgs/product_05.png" alt="">
        </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
  <div v-else class="mobile_viewrap">
    <div class="mobile_wrap">
      <mobNav :activeNav="activeNav"></mobNav>
    </div>
    <div class="mobhome_banner">
      <div class="mobhome_banner_cont">
        <img src="@/assets/mobimg/mob_product.png" />
      </div>
    </div>

    <div class="mobile_itemimg_wrap">
      <!--<div class="mobile_itemimg_view">
        <img src="@/assets/mobimg/mob_product_01.png" alt="">
      </div>-->
      <div class="mobile_itemimg_view">
        <img src="@/assets/mobimg/mob_product_02.png" alt="">
      </div>
      <div class="mobile_itemimg_view">
        <img src="@/assets/mobimg/mob_product_03.png" alt="">
      </div>
      <div class="mobile_itemimg_view">
        <img src="@/assets/mobimg/mob_product_04.png" alt="">
      </div>
      <div class="mobile_itemimg_view">
        <img src="@/assets/mobimg/mob_product_05.png" alt="">
      </div>
    </div>

    <mobFooter></mobFooter>
  </div>

</template>

<script>
  import headNav from "@/components/headNav.vue";
  import homeNav from "@/components/homeNav.vue";
  import footPage from "@/components/foot.vue";
  import "../components/scss/sobre.scss";
  import mobNav from "@/components/mobNav.vue";
  import mobFooter from "@/components/mobfooter.vue";
  import mobileOrpc from "@/mixins/index";

  export default {
    name: "Aviso",
    components: { headNav, homeNav, footPage, mobNav, mobFooter },
    mixins: [mobileOrpc],
    data() {
      return {
        activeNav: "Aviso",
        scroll: 0,
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .eshoy_about_wrap{
    width: 100%;
    height: auto;
    padding: 90px 0 140px 0;
    background: #13151A;
  }
  .eshoy_abtitle_cont{
    width: 100%;
    height: auto;
    padding-bottom: 80px;
  }
  .eshoy_abtitle_icon{
    width: 54px;
    height: 54px;
    margin: 0 auto;
  }
  .eshoy_abtitle_view{
    width: 100%;
    height: 30px;
    padding-top: 18px;
    font-size: 30px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #391C10;
    line-height: 30px;
    text-align: center;
  }
  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }
  .eshoy_abmessage_cont{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.04);
    border-radius: 20px;
    border: 1px solid #EFECEA;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 63px 64px 65px 64px;
  }
  .eshoy_abmessage_title{
    width: 100%;
    height: 22px;
    font-size: 22px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 22px;
  }
  .eshoy_abmessage_view{
    width: 100%;
    height: auto;
    padding-top: 24px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #453D39;
    line-height: 33px;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .eshoy_content_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .product_wrap{
    width: 100%;
    height: auto;
    background: #13151A;
    padding-top: 120px;
  }
  .product_cont{
    width: 1200px;
    height: auto;
    padding-bottom: 114px;
    margin: 0 auto;
  }
  .product_cont img{
    display: block;
    width: 100%;
  }
  .mobile_itemimg_wrap{
    width: 100%;
    height: auto;
    padding-bottom: 1.944444rem;
  }
  .mobile_itemimg_view{
    width: 88.89%;
    height: auto;
    margin: 1.944444rem auto 0 auto;
  }
  .mobile_itemimg_view img{
    display: block;
    width: 100%;
  }
</style>
